app.config(function ($translateProvider) {
    $translateProvider.translations('en-gb', {
        REQUEST_ERROR: 'There was an error with the request, please try again later',
        THIS_ENTITY_HAS_DEPENDENCIES: 'Record is in use. Unable to delete.'
    });
});
